import log from 'salvo-lite/log'

class ToggleClasses {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._data = JSON.parse(elem.getAttribute('data-toggle-classes'))
        this._elem = elem
    }

    onInit () {
        if (this._data.length) {
            this._loopLogic()
        } else {
            this._attachEvent(this._data)
        }
        log.debug(this._name, 'Initiated', this)
    }

    _attachEvent (data) {
        this._elem.addEventListener(data.on, evt => {
            let isValid = data.onlyThisElem ? evt.target === this._elem : true
            if (isValid) {
                evt.preventDefault()
                this._eventLogic(data)
            }
        })
    }

    _eventLogic (data) {
        let targets = document.querySelectorAll(data.target)

        if (data.classes) {
            for (let className of data.classes) {
                this._action(targets, data.method, className)
            }
        } else {
            this._action(targets, data.method, data.class)
        }
    }

    _action (targets, method, className) {
        for (let target of targets) {
            target.classList[method](className)
        }
        document.dispatchEvent(new Event('update-sticky'))
    }

    _loopLogic () {
        for (let data of this._data) {
            this._attachEvent(data)
        }
    }
}

export default ToggleClasses



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ToggleClasses.js